import React from "react";
import PropTypes from "prop-types";
import SummaryBlock from "./SummaryBlock";
import SampleReportGrid from "../details/SampleReportGrid/SampleReportGrid";
import SampleReportGridLink from "../details/SampleReportGrid/SampleReportGridLink";
import SampleReportGridFileClassificationsList from "../details/SampleReportGrid/SampleReportGridFileClassificationsList";

export const SUMMARY_FILE_CLASSIFICATIONS_ID = "file-classifications";

const SummaryFileClassifications = React.forwardRef((props, ref) => {
  const grid = {
    fields: [
      {
        heading: "File",
        component: data => (
          <SampleReportGridLink data={data} section="" {...props} />
        ),
        extraPadding: true
      },
      {
        heading: "Threat Name",
        component: data => (
          <SampleReportGridFileClassificationsList data={data} />
        )
      }
    ]
  };

  return (
    <SummaryBlock
      id={SUMMARY_FILE_CLASSIFICATIONS_ID}
      count={props.classifications.length}
      title={`File Classifications`}
      icon="file-classifications"
      ref={ref}
    >
      <SampleReportGrid grid={grid} data={props.classifications} />
    </SummaryBlock>
  );
});

SummaryFileClassifications.propTypes = {
  classifications: PropTypes.arrayOf(
    PropTypes.shape({
      classification: PropTypes.number,
      filename: PropTypes.string,
      relationship_id: PropTypes.number,
      source: PropTypes.string,
      name: PropTypes.string
    })
  )
};

export default SummaryFileClassifications;
